import React from 'react';

const ThingsSection = ({ ThingsData }) => {
    return (
        <section className="condition-section things-section">
            <div className="container">
                <div className="inner-content">
                    <div className="content-wrapper">
                        <div className="top-row">
                            <div className="left-wrap">
                                <img src={ThingsData.image} alt="Commercial Inspection" />
                            </div>
                            <div className="right-wrap">
                                <h2>{ThingsData.heading}</h2>

                                {/* ✅ Intro as <ul><li> */}
                                <ul>
                                    {ThingsData.intro.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="bottom-wrap">
                           

                            
                            <ul>
                                {ThingsData.checklist.map((point, index) => (
                                    <li key={index}>{point}</li>
                                ))}
                            </ul>

                            <div className="b-data">
                                <h5>{ThingsData.summary}</h5>
                            </div>

                            <div className="bottom-p">
                                <p>{ThingsData.standards}</p>
                            </div>

                           
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ThingsSection;
